import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class DiCacheConfigApi extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'DiCacheConfigs';

  /**
   * Lấy ra danh sách phòng ban dạng phẳng
   * @param {*} payload
   * @returns
   * tvhien 18.10.2022
   */
  async getAllAsync() {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '',
    };

    return await httpClient.getAsync(request);
  }
}

export default new DiCacheConfigApi();
